import React, { useEffect, useState, useRef, useHistory } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import Spinner from '../../../Common/Spinner';
import Parse from 'parse';
import Logo from "../../../../assets/images/logo-blue.png";
import Loading from "../../../Pages/Signup/Loading";
import { getUserProfile } from '../../../../actions/ProfileAction';
import ReactPhoneInput from "react-phone-input-2";
import Notify from '../../../Common/Notify';
import { parse, getCountryCallingCode, isValidNumber, parsePhoneNumber } from 'libphonenumber-js'
import config from '../../../../config';
import "../../../Pages/Login/Login.css";

const GoogleCallback = (props) => {
  const { history } = props;

  const dispatch = useDispatch();
  const [isloading, setIsloading] = useState(true);
  const [decodedString, setDecodedString] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [setTime, setSetTime] = useState(60);
  const [resendLimit, setResendLimit] = useState(3);
  const [maxResendLimit, setmaxResendLimit] = useState(false);
  const [validPhoneNumber, setvalidPhoneNumber] = useState(false);
  const [isSendingSMS, setisSendingSMS] = useState(false);
  const [showStatus, setshowStatus] = useState(false);
  const [validCode, setvalidCode] = useState(false);
  const [disabledInput, setdisabledInput] = useState(false);
  const [openExceedLimit, setopenExceedLimit] = useState(false);
  const [readyToSignup, setreadyToSignup] = useState(false);
  const [isVerifyingSMS, setisVerifyingSMS] = useState(false);
  const [isVerifyingCode, setisVerifyingCode] = useState(false);
  const [isResendingSMS, setisResendingSMS] = useState(false);
  const [showValidStatus, setshowValidStatus] = useState(false);
  const [phoneIsAvailable, setphoneIsAvailable] = useState(false);
  const [checkingPhoneIfAvailable, setcheckingPhoneIfAvailable] = useState(false);
  const [failedSignin, setFailedSignin] = useState(false);
  const [seconds, setSeconds] = useState(10);
  const [isRunning, setIsRunning] = useState(false);
  const [userStatus, setUserStatus] = useState("");

  const timeOutRef = useRef(null);
  const codeRef = useRef(null);
  const submitRef = useRef(null);
  const ConfirmPhoneNumberStyle = {width: "auto", fontSize: "17px", float: "right", cursor: "pointer"};
  const phoneInputStyle = {paddingLeft: "0px", marginTop: "3px"};
  
  useEffect(() => {
    const hasProcessed = localStorage.getItem("googleProcessed");

    // if (!hasProcessed) {
      const query = new URLSearchParams(window.location.search);
      const code = query.get("code");
      const user = query.get("user");
      const mail = query.get("email");
      const decodedCode = decodeURIComponent(code);
      setEmail(mail);

      // console.log('code', code)
      // console.log('user', user)
      // console.log('email', email)

      if (user === "not_verified" || user === "new_user") {
        setUserStatus(user);
        setIsloading(false);

      } else if (user === "existing_user") {
        dispatch(getUserProfile(decodedCode))
          .then((profile) => {
            // console.log('profile', profile)
            if (user === "existing_user") {
              localStorage.setItem(
                `Parse/${config.APPLICATION_ID}/currentUser`,
                JSON.stringify(profile)
              );
              localStorage.setItem("is_idled", "false");
              localStorage.setItem("is_logged_in", "true");
              localStorage.setItem("googleProcessed", "true");

              window.location.href = '/?status=success';

            } else if (user === "new_user") {
              setIsloading(false); // show registration form

            } else if (user === "not_verified") {
              setFailedSignin(true);
              setSeconds(10);
              setIsRunning(true);
              //
              setUserStatus("not_verified");
              setIsloading(false);

            }
          })
          .catch(() => {
            history.replace("/");
          });
      }

      
    // } else {
    //   window.location.href = '/?status=success';
    // }
  }, []);

  useEffect(() => {
    if (!isRunning || seconds <= 0) return;

    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [isRunning, seconds]);

  useEffect(() => {
    if (seconds === 0 && isRunning) {
      setIsRunning(false);
      window.location.href = '/';
    }
  }, [seconds, isRunning]);

  const countdown = () => {
    setSetTime((prevTime) => {
      const newTime = prevTime - 1;
      if (newTime === 0) {
        clearInterval(timeOutRef.current);
      }
      return newTime;
    });
  };

  const startTimeout = () => {
    countdown();
    timeOutRef.current = setInterval(() => {
      countdown();
    }, 1000);
  };

  useEffect(() => {
    return () => {
      clearInterval(timeOutRef.current);
    };
  }, []);

  const handlePhoneInput = (value, countryObj, event, formattedValue) => {
    const dialCode = countryObj.dialCode;
    let typedNumber = value;

    if (typedNumber.startsWith(dialCode)) {
        typedNumber = typedNumber.slice(dialCode.length);
    }
    typedNumber = typedNumber.replace(/^0+/, '');

    setshowStatus(false);
    setphoneIsAvailable(false);
    setvalidPhoneNumber(false);

    const country = getCountry(countryObj);
    
    let data = parse(value, country);
  
    let callingCode = null;
    if (typeof data.country != "undefined") {
      callingCode = getCountryCallingCode(data.country);
    }
    let isValid = isValidNumber({ phone: data.phone, country: data.country })
    let phoneIsAvailable = true;
    // if (isValid) {
    // }
  
      setphoneNumber(value);
      setvalidPhoneNumber(isValid);
  }

  const checkPhoneNumber = (e) => {
    e.preventDefault();
    // let { phoneNumber, validPhoneNumber } = this.state;
    let username = phoneNumber.replace(/\D/g,'');
    if (validPhoneNumber) {
      var User = Parse.Object.extend("User");
      var query = new Parse.Query(User);
      query.equalTo("username", username);
      sendSMSVerification(username);

      query.count().then((res) => {
        if (res >= 1) {
            setcheckingPhoneIfAvailable(false);
            setphoneIsAvailable(false);
            setshowStatus(true);
        } else {
          // this.sendSMSVerification(username);
        }
      }, (error) => {
          console.log(error)
      });
    }
  };

  const getCountry = (obj) => { 
    if (!obj || !obj.countryCode) return '';
    return obj.countryCode.toUpperCase();
  }

  const sendSMSVerification = (phoneNumber) => {
    setisSendingSMS(true);
    setdisabledInput(true);

    // let self = this;
    Parse.Cloud.run("requestOTP", {
        phoneNumber: phoneNumber
    }).then(function(res) {
        setisVerifyingSMS(true);
        setisSendingSMS(false);
        startTimeout();
    }).catch((error) => {
        if (error.message === "SMS_MAX_RETRIES_EXCEEDED") {
          callExceedLimit();
          // self.setState({
          //     isVerifyingSMS : false,
          //     isSendingSMS : false
          // })
          setisVerifyingSMS(false);
          setisSendingSMS(false);
          setdisabledInput(false);
        }
    });
  }
  const resendSMSVerification = () => {
    let username = phoneNumber.replace(/\D/g,'');

    let limit = resendLimit;
    if (limit == 0) {
      return;
    }
    let setTime;
    if (limit == 3) {
      setTime = 120;
    } else if (limit == 2) {
      setTime = 180;
    } else if (limit == 1) {
      setTime = null;
    }
    limit = limit - 1;
      if (limit === 0) {
          setmaxResendLimit(true);
      }
      setisResendingSMS(true);
      setResendLimit(limit);
      setSetTime(setTime);

      // let self = this;
      Parse.Cloud.run("requestOTP", {
          phoneNumber: username
      }).then(function(res) {
          setisVerifyingSMS(true);
          setisResendingSMS(false);
          setshowValidStatus(false);
          if (codeRef.current) {
              codeRef.current.value = "";
          }
          startTimeout();
      }).catch((error) => {
          if (error.message === "SMS_MAX_RETRIES_EXCEEDED") {
              callExceedLimit();
              // self.setState({
              //     isResendingSMS : false
              // })
            setisResendingSMS(false);
          }
      });
  }
  const verifySMSCode = (e) => {
    e.preventDefault();
    setisVerifyingCode(true);
    setshowValidStatus(false);

    // let { phoneNumber } = this.state;
    let number = phoneNumber.replace(/\D/g,'');

    let self = this;
    Parse.Cloud.run("verifyCode", {
        number: number,
        code: codeRef.current.value,
        email: email,
    }).then(function(res) {
      const { message } = res;
      if (message === "Verify success.") {
        setvalidCode(true);
        setisVerifyingCode(false);
        setshowValidStatus(true);
        setisVerifyingSMS(false);
        setIsloading(true);
        const decodedCode = decodeURIComponent(res.token);

        if (userStatus === "not_verified" || userStatus === "new_user") {

          dispatch(getUserProfile(decodedCode))
            .then((profile) => {

              if (profile !== undefined) {
                localStorage.setItem(
                  `Parse/${config.APPLICATION_ID}/currentUser`,
                  JSON.stringify(profile)
                );
                localStorage.setItem("is_idled", "false");
                localStorage.setItem("is_logged_in", "true");
                localStorage.setItem("googleProcessed", "true");

                window.location.href = '/?status=success';
                // setIsloading(false);
              } else {
                history.replace("/");
                window.location.href = '/';
              }
            })
            .catch(() => {
              history.replace("/");
              window.location.href = '/';
          });
        } else {
          signUpUser(decodedCode);
        }
      } else {
          setvalidCode(false);
          setisVerifyingCode(false);
          setshowValidStatus(true);
          //readyToSignup
      }
        
    }).catch((error) => {
        setvalidCode(false);
        setisVerifyingCode(false);
        setshowValidStatus(true);
    });
  }
  const callExceedLimit = () => {
    setopenExceedLimit(true);
  }

  const signUpUser = (decodedCode) => {
    setIsloading(true);
    dispatch(getUserProfile(decodedCode))
      .then((profile) => {
        localStorage.setItem(`Parse/${config.APPLICATION_ID}/currentUser`, JSON.stringify(profile));
      
        localStorage.setItem("is_idled", false);
        localStorage.setItem("is_logged_in", true);
        window.location.href = '/?status=success';
      })
      .catch((err) => {
        window.location.href = "/login";
      });
  }

  const steps = ['Account Details', 'Phone Validation', 'Registration'];
  let codeInputStyle = {}
  if (showValidStatus && !validCode) {
    codeInputStyle.border = "1px solid #d84b55";
    console.log("update-error")
  }

  return (
    isloading ? (
      <div
        className="loader"
        style={{
          position: "absolute",
          overflow: "hidden",
          backgroundColor: "#ccccccc2",
        }}
      >
        {/* {failedSignin && (
          <div className="card Error-Container">
            <span>Please verify your email address</span>
          </div>
        )} */}
        <div align="center">
          <div className="loader-container">
            <div>
              <div>
                <img
                  className="loader-logo"
                  src={Logo}
                  style={{
                    width: "40px",
                  }}
                  alt="Solar Suite"
                />
                <span className="loader-brand">HUBCHART</span>
              </div>
              <div className="loader-message">
                {failedSignin
                  ? <>
                      <div className="verify-error">
                        <div>Please verify your email address</div>
                        <span>Redirecting to Home page... {seconds}</span>
                      </div>
                    </>
                  : <span>Please wait... </span>
                }
                <Spinner size={5} color={"#fbba09"} loading={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div className="Login-Container">
        <div className="Form-Container">
          {/* <img className="Logo" src={Logo} alt="Hubchart Logo" />
          <h1 className="hc-primary-text">HUBCHART</h1> */}
          <div style={{ margin: '8px auto', textAlign: 'center' }}>
            <h5 style={{fontSize: "1.15rem", margin: "0 auto"}}>Sign up</h5>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 5 }}>
            {steps.map((step, index) => (
              <React.Fragment key={index}>
                <div style={{ textAlign: 'center' }}>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: '50%',
                      backgroundColor: index === 2 ? '#ffffff' : '#007bff',
                      color: index === 2 ? '#007bff' : '#fff',
                      borderColor: '#007bff',
                      borderWidth: '2px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 24,
                      fontWeight: 'bold',
                      margin: '0 auto',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    {index + 1}
                  </div>
                  <div style={{ marginTop: 12, fontSize: 11, color: '#333' }}>{step}</div>
                </div>
                {index < steps.length - 1 && (
                  <div
                    style={{
                      flex: '0 0 60px',
                      height: 6,
                      backgroundColor: '#ccc',
                      margin: '0 20px',
                      borderRadius: 2,
                    }}
                  />
                )}
              </React.Fragment>
            ))}
          </div>
        <form onSubmit={checkPhoneNumber}>
          <div className="sign-up-phone-number-form">
            <span style={{fontSize: "13px", color:"#00000096", fontWeight: "500"}}>
              Please enter your full phone number.
            </span>
            <div className="card" style={phoneInputStyle}>
              <ReactPhoneInput 
                disabled={disabledInput}
                country={'us'}
                defaultCountry={'us'}
                enableLongNumbers={true}
                onChange={handlePhoneInput}
                value={phoneNumber}
                inputStyle={{width: "100%", outline: "none", boxShadow: "none"}}
              />
              {checkingPhoneIfAvailable && <Loading style={{right: "1px", top: "-2px"}} />}
              {showStatus && phoneIsAvailable && validPhoneNumber && 
                <div style={{
                    position: "absolute",
                    right: "-2px",
                    height: "40px",
                    width: "40px"
                  }}
                >
                  <i style={{color: "#4AAD52", fontSize: "18px"}} className="fas fa-check"></i>
                </div>
              }
              {showStatus && !phoneIsAvailable && validPhoneNumber &&
                <div style={{
                    position: "absolute",
                    right: "-2px",
                    height: "40px",
                    width: "40px"
                  }}
                >
                  <i style={{color: "#d84b55", fontSize: "18px", left: "12px"}} className="fas fa-times"></i>
                </div>
              }
            </div>
            {phoneIsAvailable && <span style={{fontSize: "13px", color: "rgb(216, 75, 85)", fontWeight: "500"}}>There is an existing account associated with number.</span>}
            {!isVerifyingSMS &&
              <div>
                {showStatus && phoneIsAvailable && validPhoneNumber && <span style={{color: "#4AAD52", fontSize: "14px"}}>Phone number still available</span>}
                {showStatus && !phoneIsAvailable && validPhoneNumber && <span style={{color: "#d84b55", fontSize: "14px",}}>Phone number is already in use</span>}
              </div>
            }
            {(!validPhoneNumber && phoneNumber !== "") && (
              <span style={{fontSize: "13px", color: "rgb(216, 75, 85)", display: "block", fontWeight: "500", marginTop: "3px"}}>Invalid Phone Number</span>
            )}
          </div>
          {(!isSendingSMS) && (!disabledInput && 
            <div className="form-group" style={{marginBottom: "30px"}}>
              <button
                ref={submitRef}
                type="submit"
                className={"confirm-phonenumber"}
                style={ConfirmPhoneNumberStyle}
                disabled={!validPhoneNumber}
              >
              Send Code
              </button>
            </div>
            )
          }
          {isSendingSMS &&
            <div className="form-group" style={{position: "relative"}}>
              <Loading style={{right: "160px", top: "-10px"}}/>
              <span style={{float: "right"}}>...Sending SMS Code</span>
            </div>
          }
        </form>

      {isVerifyingSMS ? (
        <form onSubmit={verifySMSCode} style={{marginTop: "20px"}}>
          <div className="form-group">
              <span style={{fontSize: "13px", color:"#00000096", fontWeight: "500"}}>Please enter the verification code that we sent to your phone number</span>
              <div className="card" style={codeInputStyle}>
                  <input ref={codeRef} type="text" id="code" placeholder="****" maxLength="4"  required disabled={validCode}/>
                  <i className="fas fa-lock hc-primary-text"></i>
                  {isVerifyingCode && <Loading style={{right: "0px", top: "-2px"}}/>}
                  {showValidStatus && validCode && <div style={{position: "absolute", right: "-2px", height: "40px", width: "40px"}}><i style={{color: "#4AAD52", fontSize: "18px"}} className="fas fa-check"></i></div>}
                  {showValidStatus && !validCode && <div style={{position: "absolute", right: "-2px", height: "40px", width: "40px"}}><i style={{color: "#d84b55", fontSize: "18px", marginLeft: "3.5px"}} className="fas fa-times"></i></div>}
              </div>
              {!readyToSignup &&
                <div>
                  {resendLimit != 0 ?
                    <small className="form-text" style={{color: "rgb(61, 155, 233)"}}> Did not receive SMS? { setTime == 0 ? <span onClick={resendSMSVerification} className="badge badge-success" style={{fontSize: "12px", cursor: "pointer"}}>RESEND</span> : <strong>RESEND</strong>}  {setTime == 0 ? null : (setTime)}</small>
                    :
                    <small className="form-text" style={{color: "rgb(61, 155, 233)"}}> Please wait for your verification code. </small>
                  }
                </div>
              }
              {maxResendLimit &&
                <div>
                  <small className="form-text" style={{color: "rgb(61, 155, 233)"}}> Max resend limit reach. </small>
                </div>
              }
          </div>
          {isResendingSMS || !validCode &&
            <div className="form-group" style={{marginBottom: "30px"}}>
              {!isVerifyingCode &&
                <button type="submit" className="confirm-phonenumber" style={ConfirmPhoneNumberStyle}>Verify</button>
              }
            </div>
          }
          {isResendingSMS && 
            <div className="form-group" style={{position: "relative"}}>
              <Loading style={{right: "160px", top: "-10px"}}/>
              <span style={{float: "right"}}>...Sending SMS Code</span>
            </div>
          }
        </form>
      ) : ("")}

      </div>
      </div>
    )
  );
}

export default GoogleCallback;